export const DEAL_TYPE_HOMES_FOR_SALE = 1;
export const DEAL_TYPE_HOMES_FOR_RENT = 2;
export const DEAL_TYPE_PARKINGS_FOR_SALE = 7;
export const MAIN_DEAL_TYPES_ID = [DEAL_TYPE_HOMES_FOR_SALE, DEAL_TYPE_HOMES_FOR_RENT];

export const DEAL_TYPES_HOMES = {
  PROPERTY_SALE: DEAL_TYPE_HOMES_FOR_SALE,
  PROPERTY_RENT: DEAL_TYPE_HOMES_FOR_RENT,
  HOLIDAY_RENT: 3,
  RURAL_RENT: 4,
  SHARED: 5,
  PARKING_RENT: 6,
  PARKING_SALE: DEAL_TYPE_PARKINGS_FOR_SALE,
  OFFICE_RENT: 8,
  OFFICE_SALE: 9,
  LAND_SALE: 10,
  COMMERCIAL_FORECLOSURE: 11,
  COMMERCIAL_RENT: 12,
  COMMERCIAL_SALE: 13,
  INDUSTRIAL_RENT: 14,
  INDUSTRIAL_SALE: 15,
  OVERSEAS: 16,
  TEMPORARY_RENT: 17,
  UNLISTED_FORECLOSURE: 18,
};

export const PROPERTY_TYPES_GROUPED_BY_DEAL_TYPES = {
  [DEAL_TYPE_HOMES_FOR_SALE]: [
    {
      dealTypeId: DEAL_TYPES_HOMES.PROPERTY_SALE,
      translationTag: 'global_property_sale',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.PARKING_SALE,
      translationTag: 'global_property_sale_parking',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.OFFICE_SALE,
      translationTag: 'global_property_sale_office',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.LAND_SALE,
      translationTag: 'global_property_land',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.COMMERCIAL_SALE,
      translationTag: 'global_property_retail_sale',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.INDUSTRIAL_SALE,
      translationTag: 'global_property_warehouse_sale',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.OVERSEAS,
      translationTag: 'global_property_overseas',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.UNLISTED_FORECLOSURE,
      translationTag: 'global_property_unlisted_foreclosure',
    },
  ],
  [DEAL_TYPE_HOMES_FOR_RENT]: [
    {
      dealTypeId: DEAL_TYPES_HOMES.PROPERTY_RENT,
      translationTag: 'global_property_rent',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.SHARED,
      translationTag: 'global_property_flatshare',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.PARKING_RENT,
      translationTag: 'global_property_rent_parking',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.OFFICE_RENT,
      translationTag: 'global_property_rent_office',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.COMMERCIAL_FORECLOSURE,
      translationTag: 'global_property_retail_transfer',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.COMMERCIAL_RENT,
      translationTag: 'global_property_retail_rent',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.INDUSTRIAL_RENT,
      translationTag: 'global_property_warehouse_rent',
    },
    {
      dealTypeId: DEAL_TYPES_HOMES.TEMPORARY_RENT,
      translationTag: 'global_alquiler_temporario',
    },
  ],
};



// WEBPACK FOOTER //
// ./app/common/constants/homes.js